import http from '../../../../api/http';

export interface Modulo {
  id: number;
  descripcion: string;
  codigo: string;
  icono?: string;
}

export const moduloService = {
  async getAll(): Promise<Modulo[]> {
    const response = await http.get('/modulo');
    return response.data;
  },

  async getById(id: number): Promise<Modulo> {
    const response = await http.get(`/modulo/${id}`);
    return response.data;
  },

  async save(modulo: Modulo): Promise<Modulo> {
    if (modulo.id === 0) {
      const response = await http.post('/modulo', modulo);
      return response.data;
    } else {
      const response = await http.put(`/modulo/${modulo.id}`, modulo);
      return response.data;
    }
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/modulo/${id}`);
  }
};
